var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividualIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#009a80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3751 22C27.5138 22 28.4438 22.8955 28.4976 24.0214L28.5 24.1243V24.5C28.5 26.3778 27.5292 27.7834 26.0399 28.6901C24.5755 29.5816 22.607 30 20.5 30C18.3931 30 16.4246 29.5816 14.9601 28.6901C13.516 27.8109 12.5593 26.4625 12.5027 24.6694L12.5 24.5V24.1245C12.5 22.9852 13.3965 22.0561 14.522 22.0024L14.625 22H26.3751ZM20.5 10C23.2614 10 25.5 12.2386 25.5 15C25.5 17.7614 23.2614 20 20.5 20C17.7386 20 15.5 17.7614 15.5 15C15.5 12.2386 17.7386 10 20.5 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualIconGreen);
export default __webpack_public_path__ + "static/media/individual_icon_green.d1ee390ed8934ef5ade3fbbf75460cbd.svg";
export { ForwardRef as ReactComponent };